import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogs-config',
  templateUrl: './catalogs-config.component.html',
  styleUrls: ['./catalogs-config.component.scss']
})
export class CatalogsConfigComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
